import { BaseParticipanteService } from "../base/baseApiParticipantes";
import { ObjNotificaciones } from "../../config/notificaciones";

export class ParticipantesService extends BaseParticipanteService {
  async crearPostulacion(values: any) {
    try {
      const { data } = await this.axiosClient.post(`/postulaciones/`, values);
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in crearPostulacion with stack: ${error}`
      );
    }
  }

  async notaFinalPostulacion(values: any) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/notaFinalPostulacion`,
        values
      );
      return data;
    } catch (error) {
      console.error("Error en notaFinalPostulacion:", error);
      throw error; // Lanza el error original sin crear un nuevo error
    }
  }

  async cambiarTipoParticipante(id_postulacion: any, principalState: any) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/cambiarTipoParticipantePostulacion`,
        {
          id_postulacion,
          tipo_participante: principalState,
        }
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in cambiarTipoParticipante with stack: ${error}`
      );
    }
  }

  async consultarParticipante(idParticipante: any) {
    try {
      let { data } = await this.axiosClient.get(
        `/participantes/${idParticipante}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarParticipante with stack: ${error}`
      );
    }
  }

  async crearParticipante(idParticipante: any, values: any) {
    try {
      let { data } = await this.axiosClient.post(`/participantes/`, values);
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in crearParticipante with stack: ${error}`
      );
    }
  }

  async modificarParticipante(idParticipante: any, values: any) {
    try {
      let { data } = await this.axiosClient.put(
        `/participantes/${idParticipante}`,
        values
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in modificarParticipante with stack: ${error}`
      );
    }
  }

  async guardarDocumentosPostulacionApi(id_postulacion: any, values: any) {
    try {
      let { data } = await this.axiosClient.post(
        `/postulaciones/documentos/${id_postulacion}`,
        values
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarDocumentosPostulacionApi with stack: ${error}`
      );
    }
  }

  async consultarPostulaciones(id_Participante: number) {
    try {
      let { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionParticipante/${id_Participante}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarPostulaciones with stack: ${error}`
      );
    }
  }

  async consultarPostulacionesJurado(id_Participante: number) {
    try {
      let { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionJurado/${id_Participante}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarPostulaciones with stack: ${error}`
      );
    }
  }

  async consultarPostulacionCodigo(radicado: string) {
    try {
      let { data } = await this.axiosClient.get(`/postulaciones/consultarPostulacionCodigo/${radicado}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in consultarPostulaciones with stack: ${error}`);
    }
  }

  async consultarTodasPostulaciones() {
    try {
      let { data } = await this.axiosClient.get(`/postulaciones/`);
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarTodasPostulaciones with stack: ${error}`
      );
    }
  }

  async consultarPostulacionesArtistas() {
    try {
      let { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionesArtistas`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarTodasPostulaciones with stack: ${error}`
      );
    }
  }

  async consultarPostulacionesEnPorcesoArtistas() {
    try {
      let { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionesEnPorcesoArtistas`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarTodasPostulaciones with stack: ${error}`
      );
    }
  }

  async consultarPostulacionesJurados() {
    try {
      let { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionesJurados`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarPostulacionesJurados with stack: ${error}`
      );
    }
  }

  async consultarPostulacion(id_postulacion: any) {
    try {
      let { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacion/${id_postulacion}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarPostulacion with stack: ${error}`
      );
    }
  }

  async guardarDocumentosTecnicosPostulacion(
    id_postulacion: any,
    documentos: any
  ) {
    try {
      let { data } = await this.axiosClient.post(
        `/postulaciones/documentos_tecnicos/${id_postulacion}`,
        documentos
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarDocumentosTecnicosPostulacion with stack: ${error}`
      );
    }
  }

  /**
   * Escribe UN documento administrativo sin tocar los demas de la columna.
   *
   * Las rutas que guardan el listado completo reemplazan la columna entera,
   * asi que dos guardados casi simultaneos se pisan. Esta hace el leer,
   * modificar y escribir dentro de una transaccion en el servidor.
   */
  async guardarDocumentoAdministrativo(id_postulacion: any, documento: any) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/documento_administrativo/${id_postulacion}`,
        documento
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarDocumentoAdministrativo with stack: ${error}`
      );
    }
  }

  async guardarDocumentoTecnico(id_postulacion: any, documento: any) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/documento_tecnico/${id_postulacion}`,
        documento
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarDocumentoTecnico with stack: ${error}`
      );
    }
  }

  async guardarDocumentosAdministrativosPostulacion(
    id_postulacion: any,
    documentos: any
  ) {
    try {
      let { data } = await this.axiosClient.post(
        `/postulaciones/documentos_administrativos/${id_postulacion}`,
        documentos
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarDocumentosAdministrativosPostulacion with stack: ${error}`
      );
    }
  }

  async guardarDocumentosGeneralesPostulacion(
    id_postulacion: number,
    documentos: any
  ) {
    try {
      let { data } = await this.axiosClient.post(
        `/postulaciones/documentos_generales/${id_postulacion}`,
        documentos
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarDocumentosGeneralesPostulacion with stack: ${error}`
      );
    }
  }

  async guardarArchivoPostulacion(filedata: any) {
    try {
      let { data } = await this.axiosClient.post(
        `/participantes/guardarArchivo`,
        filedata,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      return data;
    } catch (error) {
      return console.error(
        `An unhandled exception in guardarArchivoPostulacion with stack: ${error}`
      );
    }
  }

  async descargarArchivo(url: string) {
    if (url !== "") {
      try {
        let data = await this.axiosClient.get(
          `/participantes/consultarArchivos/${url}`,
          {
            responseType: "blob",
          }
        );
        return data;
      } catch (error) {
        return console.error(
          `An unhandled exception in descargarArchivo with stack: ${error}`
        );
      }
    }
  }

  async cambiarEstadoPostulacion(values: any) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/cambiarEstadoPostulacion`,
        values
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in cambiarEstadoPostulacion with stack: ${error}`
      );
    }
  }

  async cambiarEstadoPostulacionJurado(values: any) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/cambiarEstadoPostulacionJurado`,
        values
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in cambiarEstadoPostulacion with stack: ${error}`
      );
    }
  }

  async guardarLinksPostulacion(id_postulacion: any, values: any) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/guardarLinksPostulacion/${id_postulacion}`,
        values
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarLinksPostulacion with stack: ${error}`
      );
    }
  }

  async actualizarNombrePropuesta(
    id_postulacion: any,
    nombrePropuesta: string
  ) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/actualizarNombrePropuesta`,
        {
          id_postulacion,
          nombrePropuesta,
        }
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in actualizarNombrePropuesta with stack: ${error}`
      );
    }
  }

  async actualizarCategoriasPropuesta(
    id_postulacion: number,
    categoria_linea_convocatoria: any
  ) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/cambiarCategoriaPostulacion`,
        {
          id_postulacion,
          categoria_linea_convocatoria,
        }
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in actualizarCategoriasPropuesta with stack: ${error}`
      );
    }
  }

  async actualizarCategoriaLineaConvocatoriaPropuesta(
    id_postulacion: string,
    categoria_linea_convocatoria: any
  ) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/cambiarCategoriasLineasConvocatoriasPostulacion`,
        {
          id_postulacion,
          categoria_linea_convocatoria,
        }
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in actualizarCategoriasPropuesta with stack: ${error}`
      );
    }
  }

  async crearSubparticipante(values: any) {
    try {
      let { data } = await this.axiosClient.post(
        `/partipantesAgregados/`,
        values
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in crearSubparticipante with stack: ${error}`
      );
    }
  }

  async eliminarSubparticipante(numero_documento: any) {
    try {
      let { data } = await this.axiosClient.delete(
        `/partipantesAgregados/${numero_documento}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in eliminarSubparticipante with stack: ${error}`
      );
    }
  }

  async eliminarPostulacion(id_postulacion: any) {
    try {
      let { data } = await this.axiosClient.delete(
        `/postulaciones/eliminarPostulacion/${id_postulacion}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in eliminarSubparticipante with stack: ${error}`
      );
    }
  }

  async eliminarPostulacionRadicado(radicado: any, documento: any) {
    try {
      let { data } = await this.axiosClient.delete(
        `/postulaciones/eliminarPostulacionRadicado/${radicado}/${documento}`,
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in eliminarSubparticipante with stack: ${error}`
      );
    }
  }

  async consultarParticipantes(postulacion_id: any) {
    try {
      let { data } = await this.axiosClient.get(
        `/partipantesAgregados/consultarParctipantesUsuario/${postulacion_id}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarParticipantes with stack: ${error}`
      );
    }
  }

  async guardarFoto(path_foto: any, documento: any) {
    try {
      const { data } = await this.axiosClient.put(
        `/participantes/guardarFoto/${documento}`,
        path_foto
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarFoto with stack: ${error}`
      );
    }
  }
  async obtenerArchivo(fileName: string) {
    try {
      // console.log(path_foto)
      const { data } = await this.axiosClient.get(
        `/participantes/consultarArchivos/${fileName}`,
        {
          responseType: "blob",
        }
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in obtenerArchivo with stack: ${error}`
      );
    }
  }

  async postulacionesAceptadas() {
    try {
      // console.log(path_foto)
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionesPorEstado/Aceptado`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in postulacionesAceptadas with stack: ${error}`
      );
    }
  }

  async consultarPostulacionesAsignarJurados() {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionesAsignarJurados`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarPostulacionesAsignarJurados with stack: ${error}`
      );
    }
  }

  async postulacionesJuradosAceptadas() {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionesJuradosPorEstado/Aceptó`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarFoto with stack: ${error}`
      );
    }
  }

  async postulacionesEstado(estado: string) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionesPorEstado/${estado}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarFoto with stack: ${error}`
      );
    }
  }

  async guardarJuradosPostulaciones(id_postulacion: number, jurados: any) {
    try {
      let { data } = await this.axiosClient.post(
        `/postulaciones/guardarJuradosPostulacion/${id_postulacion}`,
        jurados
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarFoto with stack: ${error}`
      );
    }
  }

  async generarReportePostulaciones(estado: string, fecha_inicio: string, fecha_fin: string) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/generarReporte/${estado}/${fecha_inicio}/${fecha_fin}`,
        {
          responseType: "blob",
        }
      );
      return data;
    } catch (error) {
      console.error(error);
      ObjNotificaciones.MSG_ERROR('info', 'No se encontraron datos para exportar', `No se encontraron registros en estado ${estado} con las fechas seleccionadas`);
      return null;
    }
  }

  async consultarJuradosPostualciones(idPostulacion: number) {
    try {
      let { data } = await this.axiosClient.get(
        `/postulaciones/consultarJuradosPostulacion/${idPostulacion}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarFoto with stack: ${error}`
      );
    }
  }
  async actualizarEstadoJurado(idPostulacion: any, estado_jurado: any) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/actualizarEstadoJurado/${idPostulacion}`,
        { estado_jurado }
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in guardarFoto with stack: ${error}`
      );
    }
  }
  async consultarPostulacionConCreador(
    documento: number,
    id_postulacion: string
  ) {
    try {
      let { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionConCreador/${documento}/${id_postulacion}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarPostulacionConCreador with stack: ${error}`
      );
    }
  }

  async actualizarEstadoPostulacion(payload: any) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/actualizarEstadoPostulacion`,
        payload
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarPostulacionConCreador with stack: ${error}`
      );
    }
  }

  async editarParticipantesAgregados(
    id_Participante: any,
    postulacion_id: any
  ) {
    try {
      const { data } = await this.axiosClient.post(
        `/partipantesAgregados/editarParticipantes/${id_Participante}/${postulacion_id}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in crearPostulacion with stack: ${error}`
      );
    }
  }

  async generarReporteSeguimientoPostulaciones(
    estado: string,
    fecha_inicio: string,
    fecha_fin: string
  ) {
    try {
      const { data } = await this.axiosClient.post(
        `/postulaciones/generarReporteSeguimientoPostulaciones`,
        { estado, fecha_inicio, fecha_fin },
        {
          responseType: "blob",
        }
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in crearPostulacion with stack: ${error}`
      );
    }
  }

  async actualizarPagoProyecto(id_postulacion: any, precio: any) {
    try {
      const { data } = await this.axiosClient.put(
        `/postulaciones/actualizarPagoProyecto/${id_postulacion}`,
        { precio }
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in crearPostulacion with stack: ${error}`
      );
    }
  }

  async actualizarObservacion(id_postulacion: any, observacion: any) {
    try {
      const { data } = await this.axiosClient.put(
        `/postulaciones/actualizarObservacion/${id_postulacion}`,
        { observacion }
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in actualizarObservacion with stack: ${error}`
      );
    }
  }

  //------------- FILTROS ---------------//

  async filtroEstadoJurado(estado: any) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/filtroEstadoJurado/${estado}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in crearPostulacion with stack: ${error}`
      );
    }
  }

  async filtroLineaConvocatoria(id_linea: any) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/filtroLineaConvocatoria/${id_linea}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in crearPostulacion with stack: ${error}`
      );
    }
  }

  async postulacionAceptada(documento: any) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/postulacionAceptada/${documento}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in crearPostulacion with stack: ${error}`
      );
    }
  }

  async verificarInscripcionPostulacion(obj: any) {
    try {
      const { data } = await this.axiosClient.post(
        `/postulaciones/verificarInscripcionPostulacion`,
        obj
      );
      return data;
    } catch (error) {
      return error.response.data;
    }
  }

  async obtenerResultadoEvaluacion() {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarResultadoEvaluacion`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in obetnerResultadoEvaluacion with stack: ${error}`
      );
    }
  }

  async obtenerPostulacionesByLinea(id_linea: number) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionesLinea/${id_linea}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in obetnerResultadoEvaluacion with stack: ${error}`
      );
    }
  }

  async consultarPostulacionesById(id_Participante: number) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionesById/${id_Participante}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in obetnerResultadoEvaluacion with stack: ${error}`
      );
    }
  }

  async consultarPostulacionesByCodigo(radicado: string) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarPostulacionesByCodigo/${radicado}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in obetnerResultadoEvaluacion with stack: ${error}`
      );
    }
  }

  async obtenerResultadoEvaluacionByLinea(id_linea: number) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarResultadoEvaluacionByLinea/${id_linea}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in obetnerResultadoEvaluacion with stack: ${error}`
      );
    }
  }

  async obtenerResultadoEvaluacionByCodigo(codigo: string) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarResultadoEvaluacionByCodigo/${codigo}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in obetnerResultadoEvaluacion with stack: ${error}`
      );
    }
  }

  async obtenerJuradosCriterios(id_postulacion: number) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarProyectosJuradosyCriterios/${id_postulacion}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in obetnerResultadoEvaluacion with stack: ${error}`
      );
    }
  }

  async consultarDocumentosTecnicos(id_postulacion: string) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarDocumentosTecnicos/${id_postulacion}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in obetnerResultadoEvaluacion with stack: ${error}`
      );
    }
  }

  async consultarDocumentosAdministrativos(id_postulacion: string) {
    try {
      const { data } = await this.axiosClient.get(
        `/postulaciones/consultarDocumentosAdministrativos/${id_postulacion}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in obetnerResultadoEvaluacion with stack: ${error}`
      );
    }
  }

  async consultarIdParticipante(documento: number) {
    try {
      let { data } = await this.axiosClient.get(
        `/participantes/consultarIdParticipante/${documento}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in consultarPostulacionConCreador with stack: ${error}`
      );
    }
  }

  async actualizarEstadoPostulacionArtista(id_postulacion: number, estado: string) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/actualizarEstadoPostulacionArtista/${id_postulacion}/${estado}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in actualizarEstadoAPorCompletar with stack: ${error}`
      );
    }
  }

  async validarPostulacion(id_convocatoria: number, documento: number) {
    try {
      let { data } = await this.axiosClient.get(
        `/postulaciones/validarPostulacionJurados/${id_convocatoria}/${documento}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in actualizarEstadoAPorCompletar with stack: ${error}`
      );
    }
  }

  async buscarCodigoFin(codigoPropuesta: string, numeroDocumento: string) {
    try {
      let { data } = await this.axiosClient.get(
        `/postulaciones/buscarCodigoFin/${codigoPropuesta}/${numeroDocumento}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in actualizarEstadoAPorCompletar with stack: ${error}`
      );
    }
  }

  async actualizarCodigo(codigoPropuesta: string, numeroDocumento: string, nuevoCodigoPropuesta: string) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/actualizarCodigo/${codigoPropuesta}/${numeroDocumento}/${nuevoCodigoPropuesta}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in actualizarEstadoAPorCompletar with stack: ${error}`
      );
    }
  }

  async actualizarTipoP(codigoPropuesta: string, numeroDocumento: string, tipoP: string) {
    try {
      let { data } = await this.axiosClient.get(
        `/postulaciones/actualizarTipoP/${codigoPropuesta}/${numeroDocumento}/${tipoP}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in actualizarEstadoAPorCompletar with stack: ${error}`
      );
    }
  }

  async actualizarTipoPById(id_postulacion: number, tipoP: string) {
    try {
      let { data } = await this.axiosClient.put(
        `/postulaciones/actualizarTipoPById/${id_postulacion}/${tipoP}`
      );
      return data;
    } catch (error) {
      throw new Error(
        `An unhandled exception in actualizarEstadoAPorCompletar with stack: ${error}`
      );
    }
  }
}

export default new ParticipantesService();
